export class RelativeNavigation {
  public static readonly forward: string = 'Forward';

  public static readonly back: string = 'Back';
}
